import * as React from "react";
import { styled } from "@mui/material/styles";
import InputBase from "@mui/material/InputBase";
import { SearchIcon } from "../Icons/Icons";

const Search = styled("div")(({ theme, bgColor }) => ({
  position: "relative",
  borderRadius: "8px",
  backgroundColor: bgColor,
  marginLeft: 0,
  width: "100%",
  [theme.breakpoints.up("sm")]: {
    marginLeft: theme.spacing(1),
    width: "auto",
  },
  caretColor: "#EF9011",
}));

const SearchIconWrapper = styled("div")(({ theme }) => ({
  padding: theme.spacing(0, 2),
  height: "100%",
  position: "absolute",
  pointerEvents: "none",
  display: "flex",
  alignItems: "center",
  justifyContent: "center",
}));

const StyledInputBase = styled(InputBase)(({ theme }) => ({
  color: "#7C7C8D",
  width: "100%",
  "& .MuiInputBase-input": {
    padding: theme.spacing(1, 1, 1, 0),
    paddingLeft: `calc(1em + ${theme.spacing(4)})`,
    transition: theme.transitions.create("width"),
    width: "100%",
    "&::placeholder": {
      opacity: 1,
    },
  },
}));

export function SearchBar(props) {
  return (
    <Search bgColor={props.bgColor}>
      <SearchIconWrapper>
        <SearchIcon />
      </SearchIconWrapper>
      <StyledInputBase
        placeholder={props.placeHolder}
        inputProps={{ "aria-label": "search" }}
        onChange={(e) => props.filterFunction(e.target.value)}
      />
    </Search>
  );
}
